<template>
  <div style="width: 100%">
    <el-card>
      <div class="amap-page-container">

        <el-amap-search-box
          class="search-box"
          :search-option="searchOption"
          :on-search-result="onSearchResult"
        ></el-amap-search-box>

        <div class="distance">
          <el-select v-model="value" @change="selectChange" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>


        <!-- 地图 -->
        <el-amap
          style="height: 40vh;"
          ref="map"
          vid="amap"
          :amap-manager="amapManager"
          :center="center"
          :zoom="zoom"
          :plugin="plugin"
          :events="events"
          class="amap-demo"
        >
          <!-- 标记 -->
          <el-amap-marker
            v-for="(marker, index) in markers"
            :key="'marker' + index"
            :position="marker.position"
            :animation="marker.animation"
            :vid="'amap-marker-one' + index"
            :content="marker.content"
            :icon="marker.icon"
            :clickable="true"
            :events="marker.events"
          />
          <el-amap-info-window
            v-if="c_window"
            :position="c_window.position"
            :visible="c_window.visible"
            :content="c_window.content"
          ></el-amap-info-window>

          <!-- 位置名称显示 -->
          <el-amap-text
            v-for="(marker, index) in markers"
            :key="'text' + index"
            :text="marker.text"
            :offset="marker.offset"
            :position="marker.position"
          />
        </el-amap>

      </div>
    </el-card>
  </div>
</template>

<script>
import {AMapManager} from "vue-amap";
import {attachment} from '@/api/index/index'
import Cookies from 'js-cookie'


let amapManager = new AMapManager();
export default {
  name: 'nearby_map',
  data() {
    const self = this;
    return {
      value: '1000',
      list: [],
      options: [
        {
          label: '0.5km',
          value: '500'
        },
        {
          label: '1km',
          value: '1000'
        },
        {
          label: '1.5km',
          value: '1500'
        }
      ],
      c_windows: [],
      c_window: '',
      address: null,
      searchKey: "北京",
      amapManager,
      markers: [],
      marker: [],
      searchOption: {
        // city: "北京", //搜索范围
        // citylimit: true, //限制搜索范围
        city: "",
        citylimit: false, // 不限制搜索范围搜索，比如想全国搜索
      },
      zoom: 12,
      lng: "116.377809",
      lat: "39.878726",
      center: [116.377809, 39.878726],
      // locate:false,
      loaded: false,
      events: {
        init: (o) => {

          o.getCity((result) => {
            console.log(result, 'result');
          });

          if(!localStorage.getItem('mapList')) {
             return;
          }
          this.list = JSON.parse(localStorage.getItem('mapList'));
          console.log(this.list, 'list')


          this.list.forEach((item, i) => {

            let win = {
              position: [item.longitude, item.latitude],
              content: '',
              visible: false,
              item: item
            }

            let markerContent = '' +
              '<dv class="custom-content-marker">' +
              '   <div class="close-btn">' + '￥' + item.LowestPrice.Value + ' </dv>'
            '</div>';

            let obj = {
              position: [item.longitude, item.latitude],
              // text: '￥' + item.LowestPrice.Value,
              content: markerContent,
              animation: 'AMAP_ANIMATION_BOUNCE',
              offset: [0, 0],
              events: {
                click() {

                  //弹窗信息
                  self.c_windows[i].content =
                    `<div>
                           <div>${item.HotelName}</div>
                            <div style="margin-top: 5px;">距离目的地${item.distance}</div>
                           <div style="display: flex;justify-content: space-between;margin-top: 10px;"><span class="detailBtn" style="color: #4bb9a3" comId=${item.HotelID}>查看详情</span><span style="color: red">￥ ${item.LowestPrice.Value}</span></div>
                     </div>`


                  setTimeout(() => {
                    self.bindWindowClick()
                  }, 500)

                  //给信息窗体里的判断默认传false默认不显示
                  self.c_windows.forEach((window) => {
                    window.visible = false;
                  });
                  //当前点击的圆点对应的信息窗体为true显示
                  self.c_window = self.c_windows[i];
                  self.$nextTick(() => {
                    self.c_window.visible = true;
                  });
                },
              }
            };

            self.markers.push(obj);
            self.c_windows.push(win);

            self.$nextTick()
          })
        },
        moveend: () => {
        },
        zoomchange: () => {
          console.log('zoomchange')
        },
        click: (e) => {
          let {lng, lat} = e.lnglat
          self.lng = lng
          self.lat = lat

          self.center = [lng, lat];  //设置范围中心点
          self.marker.position = [self.lng, self.lat];
          this.zoom = 15;

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })



          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                console.log(result);
                self.address = result.regeocode.formattedAddress
                self.markers = [];
                const obj = {
                  position: [lng, lat],
                  text: result.regeocode.formattedAddress,
                  offset: [0, 30],
                };
                self.markers.push(obj);
                // self.sure();
                self.$nextTick()
              }
            }
          })

          self.getAttachment();
        },
      },
      // 一些工具插件
      plugin: [
        {
          // 定位
          pName: "Geolocation",
          events: {
            init(o) {

              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(JSON.stringify(result));
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.address = result.formattedAddress;
                  self.center = [self.lng, self.lat];
                  //   console.log(self.center, 99666);
                  let o = amapManager.getMap();
                  if (!self.marker) {
                    self.marker = new AMap.Marker({
                      position: self.center,
                    });
                    self.marker.setMap(o);
                  }
                  self.marker.setPosition(self.center);
                } else {
                  // self.$message.error("位置信息，获取失败！")
                }
              });
            },
          },
        },
        {
          // 工具栏
          pName: "ToolBar",
          // locate:true, // 定位
          // direction:true, // 方向键盘是否可见
          liteStyle: true, // 精简模式

          // position:"RB", // 位置，默认为LT 代表 左上方
        },
        // "Scale", // 比例尺
        // {
        //   // 地图类型
        //   pName: "MapType",
        //   defaultType: 0,
        //   events: {
        //     init(o) {
        //       console.log(o, 'init');
        //     },
        //   },
        // },
      ],
    };
  },
  created() {
    this.center = JSON.parse(Cookies.get('mapCenter')) || [];
    if(Cookies.get('mapCenter')) {
      this.lng = this.center[0];
      this.lat = this.center[1];
    }
  },
  mounted() {
    // this.searchByHand();
  },
  methods: {
    selectChange(val) {
      this.getAttachment();
    },
    async getAttachment() {
      try {
        this.$loads.show();

        let  {data, code, msg} = await  attachment({
          longitude: this.lng,
          latitude: this.lat,
          raidus: this.value,
          check_in_date: this.$store.state.in_out_date[0],
          check_out_date: this.$store.state.in_out_date[1]
        });
        if(code == 0) {
          this.list = data.data;
          this.bindMark(data.data)

          this.$loads.hidden();

          if(data.data.length == 0) {
            this.$message({
              message: data.msg
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.$loads.hidden();

      }
    },
    bindMark(data) {
      let self = this;
      self.c_window = '';
      self.c_windows = [];
      self.markers = [];

      data.forEach((item, i) => {
        let win = {
          position: [item.longitude, item.latitude],
          content: '',
          visible: false,
          item: item
        }

        let markerContent = '' +
          '<dv class="custom-content-marker">' +
          '   <div class="close-btn">' + '￥' + item.LowestPrice.Value + ' </dv>'
        '</div>';

        let obj = {
          position: [item.longitude, item.latitude],
          // text: '￥' + item.LowestPrice.Value,
          content: markerContent,
          animation: 'AMAP_ANIMATION_BOUNCE',
          offset: [0, 0],
          events: {
            click() {
              //弹窗信息
              self.c_windows[i].content =
                `<div>
                           <div>${item.HotelName}</div>
                           <div style="margin-top: 5px;">距离目的地${item.distance}</div>
                           <div style="display: flex;justify-content: space-between;margin-top: 10px;"><span class="detailBtn" style="color: #4bb9a3" comId=${item.HotelID}>查看详情</span><span style="color: red">￥ ${item.LowestPrice.Value}</span></div>
                  </div>`;


              setTimeout(() => {
                self.bindWindowClick()
              }, 500)

              //给信息窗体里的判断默认传false默认不显示
              self.c_windows.forEach((window) => {
                window.visible = false;
              });
              //当前点击的圆点对应的信息窗体为true显示
              self.c_window = self.c_windows[i];
              self.$nextTick(() => {
                self.c_window.visible = true;
              });
            },
          }
        };

        self.markers.push(obj);
        self.c_windows.push(win);

        self.$nextTick()
      })
      let mapList = JSON.stringify(data);
      localStorage.setItem('mapList', mapList);
      Cookies.set('mapCenter',JSON.stringify(self.center));
    },
    toDetails(item) {
      let id = item.HotelID;
      let hotelName = item.name;

      this.$router.push({
        name: 'details',
        params: {
          id,
          hotelName
        }
      })
    },
    bindWindowClick() {
      const windowDomList = document.querySelectorAll('.detailBtn')
      windowDomList.forEach(i => {
        i.onclick = (e) => {
          const id = e.target.getAttribute('comId')

          let item = this.list.find(e => e.HotelID == id);
          this.toDetails(item)
          //在这里做点击的操作
        }
      })
    },
    onSearchResult(pois) {
      if (pois.length > 0) {
        // console.log(pois, 'pois')
        let {lng, lat, name, location, address} = pois[0];
        //?显示
        this.markers = [];
        const obj = {
          position: [lng, lat],
          text: address + name,
          offset: [0, 0],
        };
        this.markers.push(obj);
        this.address = address + name;
        console.log(pois, 'pois')


        let center = [lng, lat];
        this.lng = lng;
        this.lat = lat;
        this.center = [lng, lat];

        this.getAttachment();

        let o = amapManager.getMap();
        if (!this.marker) {
          this.marker = new AMap.Marker({
            position: center,
          });
          this.marker.setMap(o);
        }

        // this.marker.setPosition(center);
      }
    },
  }
};
</script>
<style lang="scss" scoped>

::v-deep .close-btn {
  padding: 12px 16px;
  background-color: #4bb9a3;
  border-radius: 4px;
  color: #ffffff;
}

::v-deep .close-btn:after {
  content: "";
  width: 0;
  border: 8px solid white;
  border-color: #4bb9a3 transparent transparent transparent;
  border-bottom: none;
  position: absolute;
  margin: 0 auto;
  top: 43px;
  left: 26px;

}


.amap-demo {
  height: 500px !important;
}

.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}
.distance {
  position: absolute;
  top: 25px;
  right: 20px;
  z-index: 90;
}
.amap-page-container {
  position: relative;
}
</style>
